$(".videoblock").each(function () {
    const videoWrap = $(this);
    const video = videoWrap.find('a.video, button.video');
    const thisVideoSrc = video.data('src');
    const thisVTTSrc = video.data('vtt-src');
    const thisVTTLabel = video.data('vtt-label');
    const thisVTTSrcLang = video.data('vtt-srclang');

    video.on( "click", function() {
        const videoHTML = '<video class="video" autoplay controls>'+
                            '<source src="'+thisVideoSrc+'" type="video/mp4" />'+
                            '<track label="'+thisVTTLabel+'" kind="subtitles" srclang="'+thisVTTSrcLang+'" src="'+thisVTTSrc+'" />'+
                        '</video>'
        video.replaceWith(videoHTML);
    });

    const videoUrl = videoWrap.find('a.video-url, button.video-url');
    const thisVideoUrlSrc = videoUrl.data('src');
    
    videoUrl.on( "click", function() {
        const videoUrlHTML = '<iframe class="video" src="'+thisVideoUrlSrc+'" title="" allowfullscreen></iframe>'
        videoUrl.replaceWith(videoUrlHTML);
    });
});